import React from "react";
import {OverviewType} from "../../../constant/CodeSpecNum";
import TextViewFileUpdater from "../../../components/files/TextViewFileUpdater";
import GroupCodeApprovalFields from "./GroupCodeApprovalFields";

function ReadRow({label, value, multiline = false}) {
    const display = value != null && String(value).trim() !== "" ? value : "—";
    return (
        <div className={`code-editor__read-row${multiline ? " code-editor__read-row--stack" : ""}`}>
            <span className="code-editor__read-label">{label}</span>
            <span className={`code-editor__read-value${multiline ? " code-editor__read-value--multiline" : ""}`}>
                {display}
            </span>
        </div>
    );
}

function formatServiceLevel(value) {
    if (!value || !OverviewType[value]) {
        return "—";
    }
    const item = OverviewType[value];
    return `${item.kor} (${item.scale})`;
}

function GroupCodeServiceReadExtras({code}) {
    return (
        <div className="group-code-current-read-extras">
            <GroupCodeApprovalFields code={code} showAfter={false} readOnly />
            <ReadRow label="목표수준" value={formatServiceLevel(code?.targetLevel)} />
            <ReadRow label="최소수준" value={formatServiceLevel(code?.minimumLevel)} />
            <div className="code-editor__read-row code-editor__read-row--stack">
                <span className="code-editor__read-label">파일업로드</span>
                <div className="code-editor__read-value code-editor__read-value--block">
                    <TextViewFileUpdater
                        readOnly
                        tableInfo={{tableName: "service_code", joinKey: code.id}}
                    />
                </div>
            </div>
        </div>
    );
}

function GroupCodeAssetReadExtras({
    code,
    showApprovalLines,
    showApprovalAfter = true,
    showBatchNumber,
    showFile,
    tableName,
}) {
    return (
        <div className="group-code-current-read-extras">
            {showApprovalLines ? (
                <GroupCodeApprovalFields code={code} showAfter={showApprovalAfter} readOnly />
            ) : null}
            {showBatchNumber ? (
                <ReadRow label="배치번호(자산코드)" value={code?.batchNumber} />
            ) : null}
            {showFile ? (
                <div className="code-editor__read-row code-editor__read-row--stack">
                    <span className="code-editor__read-label">도면업로드</span>
                    <div className="code-editor__read-value code-editor__read-value--block">
                        <TextViewFileUpdater
                            readOnly
                            tableInfo={{tableName, joinKey: code.id}}
                            isSingle
                            onlyImage
                        />
                    </div>
                </div>
            ) : null}
        </div>
    );
}

export {GroupCodeServiceReadExtras, GroupCodeAssetReadExtras};
